import { Injectable } from '@angular/core';
import { UserCacheService } from 'cad/common/store/user/services/user-cache.service';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
// import packageInfo from 'package.json';

@Injectable()
export class ConfigService {
  cadConfig: any = environment;
  version: string = require('package.json').version;

  constructor(public userCacheService: UserCacheService) {}

  public getInfoPostBaseUrl(): string {
    if (this.userCacheService
      && this.userCacheService.getUserState()
      && this.userCacheService.getUserState().user
      && this.userCacheService.getUserState().user.currentContext) {
      let assetAbbr: string = this.userCacheService.getUserState().user.currentContext.assetAbbr;


      return _.toLower(this.cadConfig.infoPostBaseUrl).replace(
        'peplmessenger',
        _.toLower(assetAbbr) + 'messenger'
      ) ;
    }
    return this.cadConfig.infoPostBaseUrl;
  }
}
